import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube } from 'react-icons/fi';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      {/* Top Strip */}
      <div className="footer-strip">
        <div className="footer-strip-inner">
          <div className="strip-item">
            <span className="strip-icon">🚚</span>
            <div>
              <h4>Free Delivery</h4>
              <p>On orders above ₹499</p>
            </div>
          </div>
          <div className="strip-divider" />
          <div className="strip-item">
            <span className="strip-icon">↩️</span>
            <div>
              <h4>Easy Returns</h4>
              <p>30-day return policy</p>
            </div>
          </div>
          <div className="strip-divider" />
          <div className="strip-item">
            <span className="strip-icon">🔒</span>
            <div>
              <h4>100% Secure Payments</h4>
              <p>UPI, Cards, Net Banking, COD</p>
            </div>
          </div>
          <div className="strip-divider" />
          <div className="strip-item">
            <span className="strip-icon">⭐</span>
            <div>
              <h4>Top Brands</h4>
              <p>5000+ brands, 500k+ products</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="footer-main-inner">
          {/* Brand Info */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">HUGE</Link>
            <p className="footer-brand-desc">
              India's Fashion Expert. Shop the latest trends in clothing, footwear, accessories, and more from 5,000+ brands.
            </p>
            <div className="footer-social">
              <button className="social-icon" aria-label="Facebook"><FiFacebook /></button>
              <button className="social-icon" aria-label="Twitter"><FiTwitter /></button>
              <button className="social-icon" aria-label="Instagram"><FiInstagram /></button>
              <button className="social-icon" aria-label="YouTube"><FiYoutube /></button>
            </div>
            <div className="app-download">
              <p>Download App</p>
              <div className="app-badges">
                <div className="app-badge">
                  <span>📱</span> App Store
                </div>
                <div className="app-badge">
                  <span>🤖</span> Google Play
                </div>
              </div>
            </div>
          </div>

          {/* Links */}
          <div className="footer-links-group">
            <h5>ONLINE SHOPPING</h5>
            <ul>
              <li><Link to="/products/men">Men</Link></li>
              <li><Link to="/products/women">Women</Link></li>
              <li><Link to="/products/kids">Kids</Link></li>
              <li><Link to="/products/home">Home & Living</Link></li>
              <li><Link to="/products/beauty">Beauty</Link></li>
              <li><Link to="/products/studio">Gift Cards</Link></li>
              <li><Link to="/products?sale=true">Sale</Link></li>
            </ul>
          </div>

          <div className="footer-links-group">
            <h5>CUSTOMER POLICIES</h5>
            <ul>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/returns">Returns Policy</Link></li>
              <li><Link to="/shipping">Shipping Policy</Link></li>
              <li><Link to="/terms">Terms of Use</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/sitemap">Sitemap</Link></li>
            </ul>
          </div>

          <div className="footer-links-group">
            <h5>EXPERIENCE HUGE</h5>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/press">Press</Link></li>
              <li><Link to="/affiliates">Become Affiliate</Link></li>
              <li><Link to="/advertise">Advertise</Link></li>
              <li><Link to="/seller">Sell on HUGE</Link></li>
            </ul>
          </div>

          <div className="footer-links-group">
            <h5>QUICK LINKS</h5>
            <ul>
              <li><Link to="/wishlist">My Wishlist</Link></li>
              <li><Link to="/cart">My Bag</Link></li>
              <li><Link to="/orders">Track Order</Link></li>
              <li><Link to="/profile">My Profile</Link></li>
              <li><Link to="/profile?tab=address">Saved Addresses</Link></li>
            </ul>
            <div className="footer-payment-methods">
              <h5>PAYMENT METHODS</h5>
              <div className="payment-icons">
                <span className="payment-badge">VISA</span>
                <span className="payment-badge">Master</span>
                <span className="payment-badge">UPI</span>
                <span className="payment-badge">COD</span>
                <span className="payment-badge">NetBanking</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>© 2024 www.huge.aksoftware.tech. All rights reserved.</p>
          <p className="footer-bottom-text">
            Powered by HUGE — Your Premium Fashion Destination
          </p>
        </div>
      </div>
    </footer>
  );
}
